<div class="modal-header">
    <div class="modal-title">Matriz de objetivos de la acción</div>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body" *ngIf="model">
    <h4>Acción {{model.Title}}</h4>

    <div class="row" *ngFor="let subaction of model.Subactions">
        <div class="col-md-12" *ngIf="subaction.Goals && subaction.Goals.length > 0">
            <table class="table table-striped w-100 table__resume no-footer">
                <thead>
                    <tr>
                        <th colspan="2" class="bg-darkgrey">Rangos de incentivo subacción {{subaction.Title}}</th>
                    </tr>
                    <tr>
                        <th class="w-50">Objetivo</th>
                        <th class="w-50">Remuneración</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let goal of subaction.Goals">
                        <td>
                            {{goal.Units}}
                        </td>
                        <td>
                            {{goal.Price | currency: 'EUR'}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-12" *ngIf="!subaction.Goals || subaction.Goals.length == 0">
            <div class="info__box"><img src="../../../../../assets/images/icons/icon-info-black.svg">
                <div>No tienes ninguna tabla de incentivos configurada para la subacción {{subaction.Title}}.</div>
            </div>
        </div>
    </div>
</div>